import { Component } from '@angular/core';

@Component({
    selector: 'ms-speed-reading-header',
    templateUrl: './speed-reading-header.component.html',
    styleUrls: ['./speed-reading-header.component.scss'],
    standalone: false
})
export class SpeedReadingHeaderComponent {

}
